import { DROPDOWN_ACTIVE_CLASS } from "./constants";

/**
 * @function
 * @description - Initialiaze dropdown toggle event
 * @param {Element} $triggerElement - Dropdown trigger element
 * @param {Element} $dropdown - Dropdown element
 */
const initDropdownUser = ($triggerElement, $dropdown) => {
    $triggerElement.find(".js-user-dropdown-toggle").on("click", () => {
        if ($dropdown.is(":hidden")) { $triggerElement.addClass("ct-user-dropdown--shown"); }

        $dropdown.stop().slideToggle("200", () => {
            if ($dropdown.is(":hidden")) { $triggerElement.removeClass("ct-user-dropdown--shown"); }
        });
    });
};

/**
 * @function
 * @description - Initialiaze dropdown toggle event on the My products dropdown list in header
 * @param {Element} $$myProductsContainer - Dropdown trigger element
 */
const initDropdownMenus = () => {
    const toggleElems = document.querySelectorAll(".ct-dropdown:not(.disabled) [data-toggle='ct-dropdown']");

    // Attach the event listener to each of the elements and provide the needed functionality
    toggleElems.forEach(elem => {
        if (elem.classList.contains(DROPDOWN_ACTIVE_CLASS)) { return; }

        elem.addEventListener("click", () => {
            elem.parentElement.classList.toggle("brand-active");
            $(elem).siblings(".js-dropdown-menu").slideToggle(300, () => {
                $(elem).attr("aria-expanded", $(elem).siblings(".js-dropdown-menu").is(":visible"));
            });
        });
        elem.classList.add(DROPDOWN_ACTIVE_CLASS);
    });

    // Treat the case when clicking anywhere outside and close the dropdown, except when clicking on certain elements
    document.addEventListener("click", e => {
        var $stopperElements = $(".ct-dropdown:not(.disabled) [data-toggle='ct-dropdown'], a.my-products-link, .ct-dropdown-item, .js-dropdown-menu").add(".ct-dropdown:not(.disabled) [data-toggle='ct-dropdown']").parent();
        if ($stopperElements !== e.target && !$stopperElements.has(e.target).length) {
            $(toggleElems).parent(".ct-dropdown").removeClass("brand-active");
            $(toggleElems).siblings(".js-dropdown-menu").slideUp(300);
            $(toggleElems).attr("aria-expanded", "false");
        }
    });
};

export { initDropdownUser, initDropdownMenus };
